import { css } from '@emotion/react'
import { ExternalStyles, HFlow, Text } from 'bold-ui'
import { FieldStatusEnum } from 'components/form'
import { TextStatus } from 'components/text/TextStatus'

interface ObservacaoProps {
  observacao?: string
  italic?: boolean
  style?: ExternalStyles
  status?: FieldStatusEnum
}

export const Observacao = (props: ObservacaoProps) => {
  const { observacao, style, status, italic = true } = props
  const styles = createStyles(style)

  if (!observacao) {
    return null
  }

  return (
    <HFlow hSpacing={0.2} style={styles.container}>
      <Text fontWeight='bold'>Observações: </Text>
      <TextStatus status={status} fontStyle={italic && 'italic'} style={styles.text}>
        {props.observacao}
      </TextStatus>
    </HFlow>
  )
}

const createStyles = (style: ExternalStyles) => ({
  container: css(
    css`
      padding: 0.5rem 0;
    `,
    style
  ),
  text: css`
    word-break: break-all;
  `,
})
